const Questions = {
  namespaced: true,
  state: {
    allQuestions: [
      {
        id: 1,
        card_name: "Nome do Campeonato",
        question: "Qual o nome do seu campeonato?",
        hint: "Nome do Torneio",
        input: true,
        options: null,
        helper: "name",
      },
      {
        id: 2,
        card_name: "Modalidade",
        question: "Qual a modalidade?",
        input: false,
        options: [
          { option: "Futsal", id: 1 },
          { option: "Society", id: 2 },
          { option: "Futebol de Campo", id: 3 },
        ],
        helper: "modality_id",
      },
      {
        id: 3,
        card_name: "Quantidade de equipes",
        question: "Quantas equipes irão disputar o torneio?",
        hint: "Quantidade de Equipes",
        input: true,
        options: null,
        helper: "number_teams",
        is_numeric: true,
      },
      {
        id: 4,
        card_name: "Grupos",
        question: "Quantos grupos?",
        hint: "'0' para mata-mata",
        input: true,
        options: null,
        helper: "number_groups",
        is_numeric: true,
      },
      {
        id: 5,
        card_name: "Times por Grupos",
        question: "Quantas equipes em cada grupo?",
        hint: "Número de Equipes",
        input: true,
        options: null,
        helper: "teams_per_group",
        is_numeric: true,
      },
      {
        id: 6,
        card_name: "Logo",
        question: "Deseja adicionar a logo do torneio?",
        hint: "Logo",
        input: true,
        options: null,
        helper: "name", //soh para poder liberar o botao
      },
    ],
    oneQuestion: null,
  },
  mutations: {
    getOneQuestion(state, id) {
      state.allQuestions.forEach((el) => {
        if (id == el.id) {
          state.oneQuestion = el;
        }
      });
    },
  },
  actions: {
    showOneQuestion(context, id) {
      context.commit("getOneQuestion", id);
    },
  },
};
export default Questions;
